export var ExperimentSearchParameterKeys;
(function (ExperimentSearchParameterKeys) {
    ExperimentSearchParameterKeys["revision"] = "er";
    ExperimentSearchParameterKeys["variants"] = "ev";
})(ExperimentSearchParameterKeys || (ExperimentSearchParameterKeys = {}));
export const noRevisionId = "";
